import {useLocation} from 'react-router-dom'
import {useMemo} from 'react'
import {useIsFeatureEnabledForSelectedCustomerCountry} from '../../../../FeatureFlags'

export const useIsSplitLoadEnabled = (): boolean => {
  const location = useLocation()
  const isSplitLoadFeatureEnabled =
    useIsFeatureEnabledForSelectedCustomerCountry('OrderIntakeSplitLoad')

  const hasSplitLoadFeature = useMemo(() => {
    const searchParams = new URLSearchParams(location.search)
    const isSplitLoadMode = searchParams.get('loadType') === 'splitLoad'

    return isSplitLoadMode && isSplitLoadFeatureEnabled
  }, [isSplitLoadFeatureEnabled, location.search])

  return hasSplitLoadFeature
}
